module.exports = __webpack_public_path__ + "media/images/emblems/Lyss-coat_of_arms-24388b15cd0730f69e5c4dea93f07e5b.svg";